import { ROUTE_VARIANT_OVERRIDE_COOKIE } from "./routeVariant";
function readCookieVariant() {
  if (typeof document === "undefined") {
    return undefined;
  }
  var match = document.cookie.match(new RegExp("(?:^|; )".concat(ROUTE_VARIANT_OVERRIDE_COOKIE, "=(default|inverted)")));
  return match ? match[1] : undefined;
}
function getClientRouteVariant() {
  var _readCookieVariant;
  var envValue = process.env.NEXT_PUBLIC_ROUTE_VARIANT;
  if (envValue === "default" || envValue === "inverted") {
    return envValue;
  }
  return (_readCookieVariant = readCookieVariant()) !== null && _readCookieVariant !== void 0 ? _readCookieVariant : "default";
}

/**
 * The URL that currently reaches the local v2 patient implementation.
 * Always same-zone (safe for next/link and router.push) — the v2
 * implementation is, by construction, always served locally in both
 * variants; only the literal path changes.
 */
export function getPatientRoute() {
  return getClientRouteVariant() === "inverted" ? "/patients" : "/patients-v2";
}

/**
 * The URL that currently reaches qtrack-lc's patient pages. Used as the
 * viewer Back fallback when the page the viewer was opened from is unknown
 * (e.g. a pasted viewer URL). Always cross-zone — navigate with
 * window.location, never next/link or router.push.
 */
export function getRemotePatientRoute() {
  return getClientRouteVariant() === "inverted" ? "/patients-v2" : "/patients";
}

/**
 * The URL that currently reaches the local v2 worklist implementation.
 * See getPatientRoute() for why this is always same-zone.
 */
export function getWorklistRoute() {
  return getClientRouteVariant() === "inverted" ? "/worklist" : "/worklist-v2";
}
function matchesRouteRoot(pathname, root) {
  return pathname === root || pathname.startsWith("".concat(root, "/"));
}

/**
 * True when a Next.js router pathname belongs to the local v2 patient
 * implementation — either its real page (/patients-v2) or the /patients
 * shim that re-exports it under the inverted variant.
 */
export function isLocalPatientsPathname(pathname) {
  return matchesRouteRoot(pathname, "/patients-v2") || matchesRouteRoot(pathname, "/patients");
}

/**
 * True when a Next.js router pathname belongs to the local v2 worklist
 * implementation — either /worklist-v2 or the /worklist shim.
 */
export function isLocalWorklistPathname(pathname) {
  return matchesRouteRoot(pathname, "/worklist-v2") || matchesRouteRoot(pathname, "/worklist");
}